import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useWorkspacePeopleStyles = makeStyles({
  page: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflowY: "auto",
    backgroundColor: projectIqTokens.bg,
    fontFamily: projectIqTokens.fontFamily,
    padding: designTokens.spacing[8],
  },
  pageContent: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[6],
    width: "100%",
  },
  root: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[6],
  },
  saveStatus: {
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.muted,
    minHeight: "18px",
  },
  saveStatusSaved: {
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.green,
    minHeight: "18px",
  },
  saveStatusError: {
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.rust,
    minHeight: "18px",
  },
});
